import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { FaArrowLeft } from 'react-icons/fa';
import { COLORS } from '../../../../../../constants/radar';

const StartAssignmentStep = ({
  startMessage,
  isAssignmentCompleted,
  // ADR-014 §7: parent session closed (snapshot close) => frozen, read-only
  sessionLocked = false,
  isDirty,
  startingAssignment,
  handleStartAssignment
}) => {
  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <Box sx={{ 
          width: 32,
          height: 32,
          borderRadius: '50%',
          bgcolor: COLORS.PRIMARY,
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mr: 2,
          fontSize: '16px',
          fontWeight: 500
        }}>
          1
        </Box>
        <Typography variant="h6" sx={{ color: COLORS.PRIMARY }}>
          Start Assignment
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary' }}>
          Welcome to Skills Matrix Assessment
        </Typography>
        <Typography variant="body1">
          {startMessage}
        </Typography>
      </Box>

      {/* ADR-014: the session was closed before this assessment was started. */}
      {sessionLocked && (
        <Box
          sx={{
            mb: 4,
            p: 2,
            borderRadius: '8px',
            backgroundColor: '#F1F5F9',
            border: '1px solid #94A3B8'
          }}
        >
          <Typography variant="body2" sx={{ color: '#475569' }}>
            <strong>Session closed.</strong> This feedback session has been closed. The
            assessment is preserved exactly as it was and can no longer be started or edited.
          </Typography>
        </Box>
      )}

      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'flex-end',
        mt: 4,
        pt: 3,
        borderTop: '1px solid',
        borderColor: 'divider'
      }}>
        <Box
          onClick={() => !isAssignmentCompleted && !sessionLocked && !isDirty && !startingAssignment && handleStartAssignment(isDirty)}
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: 'white',
            backgroundColor: COLORS.PRIMARY,
            cursor: isAssignmentCompleted || sessionLocked || isDirty || startingAssignment ? 'not-allowed' : 'pointer',
            fontSize: '14px',
            fontWeight: 500,
            padding: '8px 16px',
            borderRadius: '4px',
            transition: 'all 0.2s ease',
            opacity: isAssignmentCompleted || sessionLocked || isDirty ? 0.4 : (startingAssignment ? 0.7 : 1),
            '&:hover': {
              opacity: isAssignmentCompleted || sessionLocked || isDirty ? 0.4 : (startingAssignment ? 0.7 : 0.9)
            }
          }}
        >
          {startingAssignment ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              Starting...
              <CircularProgress 
                size={16} 
                thickness={4} 
                sx={{ color: 'white' }} 
              />
            </Box>
          ) : (
            sessionLocked ? 'Session Closed' : (isAssignmentCompleted ? 'Assignment Completed' : 'Start Assessment')
          )}
          {!startingAssignment && !isAssignmentCompleted && <FaArrowLeft style={{ marginLeft: '8px', transform: 'rotate(180deg)' }} />}
        </Box>
      </Box>
    </Box>
  );
};

export default StartAssignmentStep; 